import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlTaskRestService {
  static async getStatus(): Promise<any> {
    return AxiosService.get('/adaptermssql/tasks/getStatus')
  }
}

export default MssqlTaskRestService
